import type React from "react";
import styles from "./Button.module.css";

interface ButtonProps extends React.ComponentProps<"button"> {
	children: React.ReactNode;
	variant?: "primary" | "secondary" | "outline";
	size?: "md" | "sm";
	className?: string;
}

export const Button = ({
	children,
	variant = "primary",
	size = "md",
	className = "",
	...props
}: ButtonProps) => {
	const sizeClass = size === "sm" ? styles["btn-sm"] : "";
	const variantClass = styles[`btn-${variant}`];
	return (
		<button
			className={`${styles.btn} ${variantClass} ${sizeClass} ${className}`}
			{...props}
		>
			{children}
		</button>
	);
};
